<template>
  <div data-vue-component-name="FunctionalityAreTemporarilyLimited">
    <span class="text">За додатковою інформацією звертайтеся за телефонами
      <a href="tel:+380989857293">+380 (98) 985-72-93</a>,
      <a href="tel:+380668856370">+380 (66) 885-63-70</a>,
      <a href="tel:+380682838345">+380 (68) 283-83-45</a>
      або
      <a href="tel:+380508810704">+380 (50) 881-07-04</a></span>
  </div>
</template>

<script>
export default {
  name: 'FunctionalityAreTemporarilyLimited',
};
</script>

<style lang="scss" scoped>
[data-vue-component-name="FunctionalityAreTemporarilyLimited"] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  padding: 9px 16px 9px 9px;
  background: red;
  text-align: center;
  z-index: 1;
  position: relative;

  img {
    margin-right: 4px;
  }

  .text {
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.04px;
  }

  a {
    color: #fff;
    text-decoration: none;
  }
}
</style>
